import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';

import "bootstrap/dist/css/bootstrap.min.css";
import 'react-toastify/dist/ReactToastify.css';
import "./assets/styles/global.css";
import "./assets/styles/form.css";
import "./assets/icons/phosphor/styles.min.css";
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import HomeScreen from "./pages/home/Index";
import TrashList from "./pages/trash/TrashList";
import TrashAdd from "./pages/trash/TrashAdd";
import Profile from "./pages/profile/Index";
import ProfileForm from "./pages/profile/Form";
import ProfilePassword from "./pages/profile/Password";
import ArticleList from "./pages/article/Index";
import ArticleDetail from "./pages/article/Detail";
import MutationDetail from "./pages/mutation/Index";
import MutationHistory from "./pages/mutation/Detail";
import MutationProof from "./pages/mutation/Proof";
import BalanceDetail from "./pages/balance/Index";
import PartnerList from "./pages/partner/Index";
import PartnerDetail from "./pages/partner/Detail";
import Notifikasi from "./pages/notifikasi/List";
import CartList from "./pages/cart/Index";


function App() {
  return (
    <div className="App">
      <BrowserRouter basename="/aksi/nasabah">
        <Routes>
          <Route exact path="/" element={<Login />} />
          <Route exact path="/register" element={<Register />} />
          <Route exact path="/forgot-password" element={<ForgotPassword />} />
          <Route exact path="/reset-password" element={<ResetPassword />} />
          <Route exact path="/home" element={<HomeScreen />} />
          <Route exact path="/trash" element={<TrashList />} />
          <Route exact path="/trash/done" element={<TrashList />} />
          <Route exact path="/trash/cancel" element={<TrashList />} />
          <Route exact path="/trash/add" element={<TrashAdd />} />
          <Route exact path="/profile" element={<Profile />} />
          <Route exact path="/profile/edit" element={<ProfileForm />} />
          <Route exact path="/profile/change-password" element={<ProfilePassword />} />
          <Route exact path="/news" element={<ArticleList />} />
          <Route exact path="/news/:id" element={<ArticleDetail />} />
          <Route exact path="/mutation/:id" element={<MutationDetail />} />
          <Route exact path="/mutation/:id/history" element={<MutationHistory />} />
          <Route exact path="/mutation/:id/history/:slug" element={<MutationProof />} />
          <Route exact path="/balance/:id" element={<BalanceDetail />} />
          <Route exact path="/partner" element={<PartnerList />} />
          <Route exact path="/partner/verify" element={<PartnerList />} />
          <Route exact path="/partner/:id" element={<PartnerDetail />} />
          <Route exact path="/notification" element={<Notifikasi />} />
          <Route exact path="/cart" element={<CartList />} />
        </Routes>
      </BrowserRouter>

      <ToastContainer
        position="top-right"
        autoClose={6000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
}

export default App;